/* eslint-disable react/destructuring-assignment */
import React from 'react';
import cx from 'classnames';
import QuoteItemSection from '../QuoteItemSection';
import styles from './QuoteItem.module.scss';
import Text from '../../atoms/Text';
import ToolTip from '../ToolTip';
import { SectionProps } from '../QuoteItemSection/QuoteItemSection.types';
import { StyleSheetColor, StyleSheetColorType } from '../../shared/types/styleSheetColors.types';

export const LegacySectionItems = (contentArray: any, popular: string, tooltipFillColor?: StyleSheetColorType) => {
  return (
    <>
      {contentArray.map((content) => {
        return (
          <div key={content.title} className={styles.line}>
            <div className={styles.textAndTooltip}>
              <Text className={styles.text}>{content.title}</Text>
              {popular && content.tooltip && (
                <ToolTip className={styles.tooltip} fillColor={tooltipFillColor ?? StyleSheetColor.Primary}>
                  <Text>{content.tooltip}</Text>
                </ToolTip>
              )}
            </div>
            <Text className={cx(styles.bold, styles.noTopMargin)}>{content.value}</Text>
          </div>
        );
      })}
    </>
  );
};
export const SectionItems = (
  sectionProps: SectionProps[],
  popularQuote: boolean,
  currency?: string,
  locale?: string
) => {
  return <QuoteItemSection popular={popularQuote} sections={sectionProps} currency={currency} locale={locale} />;
};

export const ShowItems = (
  sectionProps: SectionProps[],
  contentArray,
  popularQuote: boolean,
  popular: string,
  currency?: string,
  locale?: string,
  tooltipFillColor?: StyleSheetColorType
) => {
  return sectionProps
    ? SectionItems(sectionProps, popularQuote, currency, locale)
    : LegacySectionItems(contentArray, popular, tooltipFillColor);
};
